import React from "react";
export const languages = [
  {
    code: "tr",
    name: "Türkçe",
    dir: "ltr",
    country_code: "TR",
  },
  {
    code: "en",
    name: "English",
    dir: "ltr",
    country_code: "GB",
  },
  {
    code: "ar",
    name: "العربية",
    dir: "rtl",
    country_code: "SA",
  },
  {
    code: "de",
    name: "Deutsch",
    dir: "ltr",
    country_code: "DE",
  },
  {
    code: "es",
    name: "Española",
    dir: "ltr",
    country_code: "ES",
  },
  {
    code: "fa",
    name: "فارسی",
    dir: "rtl",
    country_code: "IR",
  },
  {
    code: "fil",
    name: "Pilipinas",
    dir: "ltr",
    country_code: "PH",
  },
  {
    code: "fr",
    name: "Français",
    dir: "ltr",
    country_code: "FR",
  },
  {
    code: "hi",
    name: "हिंदी",
    dir: "ltr",
    country_code: "IN",
  },
  {
    code: "id",
    name: "Bahasa Indonesia",
    dir: "ltr",
    country_code: "ID",
  },
  {
    code: "it",
    name: "Italiana",
    dir: "ltr",
    country_code: "IT",
  },
  {
    code: "ja",
    name: "日本",
    dir: "ltr",
    country_code: "JP",
  },
  {
    code: "ko",
    name: "한국인",
    dir: "ltr",
    country_code: "KR",
  },
  {
    code: "ml",
    name: "Malaysia",
    dir: "ltr",
    country_code: "MY",
  },
  {
    code: "ms",
    name: "Malaysia",
    dir: "ltr",
    country_code: "MY",
  },
  {
    code: "pt",
    name: "Português",
    dir: "ltr",
    country_code: "PT",
  },
  {
    code: "ru",
    name: "Русский",
    dir: "ltr",
    country_code: "RU",
  },
  {
    code: "th",
    name: "แบบไทย",
    dir: "ltr",
    country_code: "TH",
  },
  {
    code: "uk",
    name: "українська",
    dir: "ltr",
    country_code: "UA",
  },
  {
    code: "ur",
    name: "اردو",
    dir: "rtl",
    country_code: "PK",
  },
  {
    code: "vi",
    name: "Tiếng Việt",
    dir: "ltr",
    country_code: "VN",
  },
  {
    code: "zh",
    name: "中国人",
    dir: "ltr",
    country_code: "CN",
  },
];
